<script setup lang="ts">
import type { CmsElementHeroSlider } from "~/composables/useCustom";
import Slider from "../slider/index.vue"

const props = defineProps<{
  content: CmsElementHeroSlider;
  class: any;
  style: any;
}>();

const slides = props.content?.config?.sliderCollection?.value ?? [];
</script>
<template>
  <div :style="props.style" :class="props.class">
    <Slider v-if="slides.length" :slides="slides" />
  </div>
</template>
